import { toast } from "react-toastify";
import { GlobalConstants } from "../../GlobalConstants";
import { GlobalVariables } from "../../GlobalVariables";
import { ISelectData } from "./elements/Forms/SelectInput";
import { IReceiptData } from "../../ApiCalls";

export const checkReceiptData = (receipt: IReceiptData, coOwnersArray: ISelectData[], isImageError: boolean): boolean => {
    if (process.env.NODE_ENV !== 'test') {
        console.log('checkReceiptData:', receipt, coOwnersArray, isImageError);
    }

    if (isImageError) {
        toast.error(GlobalConstants.MESSAGES.ERROR.IMAGE);
        return false;
    }

    if (receipt.transaction_date === null || receipt.transaction_date === '') {
        toast.error(GlobalConstants.MESSAGES.ERROR.FORMS.MISSING.TRANSACTION.DATE);
        return false;
    }

    if (receipt.amount === null || receipt.amount === '') {
        toast.error(GlobalConstants.MESSAGES.ERROR.FORMS.MISSING.TRANSACTION.AMOUNT);
        return false;
    }

    if (parseFloat(receipt.amount) >= 50.0 && (receipt.user_description === null || receipt.user_description === '')) {
        toast.error(GlobalConstants.MESSAGES.ERROR.FORMS.MISSING.DESCRIPTION);
        return false;
    }

    if ((receipt.currency === null && receipt.matched_bank_transaction_id === null) || (receipt.currency === '' && receipt.matched_bank_transaction_id === null)) {
        toast.error(GlobalConstants.MESSAGES.ERROR.FORMS.MISSING.TRANSACTION.CURRENCY);
        return false;
    }

    const selectedAccountingCategory = GlobalVariables.accountingCategoriesFiltered(receipt.user_description).find(o => receipt.maris_category_id !== null && receipt.maris_category_id !== -1 && parseInt(o.value) === receipt.maris_category_id);
    if (selectedAccountingCategory === undefined || ['', '-1', undefined].includes(selectedAccountingCategory.value)) {
        toast.error(GlobalConstants.MESSAGES.ERROR.FORMS.MISSING.CATEGORY);
        return false;
    }

    if (GlobalVariables.coOwners.length > 1 && coOwnersArray.find(o => o.value === receipt.co_owner_name) === undefined) {
        toast.error(GlobalConstants.MESSAGES.ERROR.FORMS.MISSING.COOWNER);
        return false;
    }

    return true;
}

export const allowConfirm = (receipt: IReceiptData) => {
    return !(receipt.receipt_type !== null && receipt.receipt_type !== 'petty_cash');
}

export const requiresManagementAttention = (receipt: IReceiptData) => {
    return receipt.receipt_type !== 'petty_cash';
}